import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Typography, Box, Button } from '@mui/material';

const TermsPage = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" gutterBottom>
          {t('footer.terms.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.introduction')}
        </Typography>

        {/* Section 1: Definitions */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section1Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section1Content')}
        </Typography>

        {/* Section 2: Services */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section2Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section2Content')}
        </Typography>

        {/* Section 3: User Roles */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section3Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section3Content')}
        </Typography>

        {/* Subsection 3.1: Buyer Role */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section3.1Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section3.1Content')}
        </Typography>

        {/* Subsection 3.2: Seller Role */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section3.2Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section3.2Content')}
        </Typography>

        {/* Subsection 3.3: Verification Worker Role */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section3.3Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section3.3Content')}
        </Typography>

        {/* Subsection 3.4: Administrator Role */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section3.4Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section3.4Content')}
        </Typography>

        {/* Section 4: Account Registration */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section4Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section4Content')}
        </Typography>

        {/* Section 5: Payments */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section5Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section5Content')}
        </Typography>

        {/* Section 6: Privacy and Data Protection */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section6Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section6Content')}
        </Typography>

        {/* Section 7: Liability */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section7Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section7Content')}
        </Typography>

        {/* Section 8: Changes to Terms */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section8Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section8Content')}
        </Typography>

        {/* Section 9: Dispute Resolution */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section9Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section9Content')}
        </Typography>

        {/* Section 10: Contact */}
        <Typography variant="h6" gutterBottom>
          {t('footer.terms.section10Title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('footer.terms.section10Content')}
        </Typography>

      
        
      </Box>
    </Container>
  );
};

export default TermsPage;
